import './CreditNotesList.css';
import { useNavigate } from 'react-router-dom';

const CreditNotesList = ({ data }) => {
    const navigate = useNavigate();

    const flattenedData = [];
    data.forEach((order) => {
        if (order.creditNotes && order.creditNotes.length > 0) {
            order.creditNotes.forEach((creditNote) => {
                flattenedData.push({
                    ...order,
                    creditNote,
                    creditNoteId: creditNote._id,
                });
            });
        }
    });

    const cnTime = (row) => {
        const d = row.creditNote?.date;
        const t = d ? new Date(d).getTime() : 0;
        return Number.isFinite(t) ? t : 0;
    };
    const dataToUse = flattenedData.sort((a, b) => {
        const tb = cnTime(b);
        const ta = cnTime(a);
        if (tb !== ta) return tb - ta;
        return (
            Number(b.creditNote?.creditNoteNumber || 0) -
            Number(a.creditNote?.creditNoteNumber || 0)
        );
    });

    return (
        <div className="ordersv2-table-wrapper creditnoteslist">
            <table className="ordersv2-table">
                <thead>
                    <tr>
                        <th>Credit note #</th>
                        <th>Order #</th>
                        <th>Date</th>
                        <th>Customer</th>
                    </tr>
                </thead>
                <tbody>
                    {dataToUse.map((row) => (
                        <tr
                            key={`${row._id}-${row.creditNoteId}`}
                            onClick={() =>
                                navigate(`/creditnote/${row._id}?creditNoteId=${row.creditNoteId}`)
                            }
                        >
                            <td className="ordersv2-order-num">{row.creditNote.creditNoteNumber}</td>
                            <td>{row.orderNumber || row.id}</td>
                            <td>
                                {new Intl.DateTimeFormat('en-GB', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }).format(new Date(row.creditNote.date))}
                            </td>
                            <td>
                                <div className="ordersv2-shipping-info">
                                    <p>{row.deliveryname || row.deliveryName}</p>
                                    <p>{row.deliverystreet || row.deliveryStreet}</p>
                                    <p>{row.deliverycity || row.deliveryCity}</p>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CreditNotesList;
